import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import { CUSTOMER_PORTAL_URL } from '../../constants/links';

const EBilling = () => {
  return (
    <div>
      <SimpleHero
        title="Paperless statements, simplified"
        subtitle="Fast, secure e‑statements and payments. Reduce paper, increase convenience."
        primaryLabel="Enroll now"
        primaryHref={CUSTOMER_PORTAL_URL}
        variant="sofi"
        badges={["Convenient","Secure","Eco‑friendly"]}
      />
      <FeatureList
        items={[
          { title: 'Convenient', desc: 'Access statements anytime, on any device.' },
          { title: 'Secure', desc: 'Encrypted delivery keeps your info safe.' },
          { title: 'Eco‑friendly', desc: 'Go green with paperless billing.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a
            className="btn btn-gn-primary"
            href={CUSTOMER_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get started
          </a>
        </div>
      </section>
    </div>
  );
};

export default EBilling;
